import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiException, HttpValidationProblemDetails, IdentityClient, ResetPasswordRequest } from '../../api_identity/api';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  email = '';
  code = '';
  resetSuccess = false;
  resetError = false;
  errorMessages: string[] = [];
  submitting = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private identityClient: IdentityClient
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.code = this.route.snapshot.queryParamMap.get('code') ?? '';

    this.resetForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    });
  }

  get passwordMismatch(): boolean {
    const newPassword = this.resetForm.get('newPassword')?.value;
    const confirmPassword = this.resetForm.get('confirmPassword')?.value;
    return confirmPassword?.length > 0 && newPassword !== confirmPassword;
  }

  get missingToken(): boolean {
    return !this.email || !this.code;
  }

  onSubmit(): void {
    if (!this.resetForm.valid || this.passwordMismatch || this.submitting) {
      return;
    }

    this.submitting = true;
    this.resetError = false;
    this.errorMessages = [];

    const request = new ResetPasswordRequest({
      Email: this.email,
      ResetCode: this.code,
      NewPassword: this.resetForm.get('newPassword')?.value
    });

    this.identityClient.resetPassword(request).subscribe({
      next: () => {
        this.resetSuccess = true;
        this.submitting = false;
      },
      error: (err) => {
        this.submitting = false;

        if (err instanceof HttpValidationProblemDetails && err.errors) {
          this.errorMessages = Object.values(err.errors).flat();
        } else if (ApiException.isApiException(err) && err.status === 429) {
          this.errorMessages = ['Too many requests. Please wait a few minutes before trying again.'];
        } else {
          this.errorMessages = ['The reset link is invalid or has expired. Please request a new password reset.'];
        }

        this.resetError = this.errorMessages.length > 0;
      }
    });
  }
}
